module.exports = __webpack_public_path__ + "media/images/pages/img_cover_left_05-96ff0c3328c229bd8e7004c6d7e59bda.jpg";